import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import { Button } from './components/ui/button';

const AboutPage: React.FC = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/about-soroban.md')
      .then(res => res.text())
      .then(setContent);
  }, []);

  return (
    <div className="container mx-auto p-4 max-w-3xl">
      <img src="/soroban-header-thin.jpg" alt="Soroban" className="w-full mb-4 rounded" />
      <Link to="/">
        <Button variant="outline" className="mb-4">← Back to Practice</Button>
      </Link>
      <article className="prose prose-slate max-w-none">
        <ReactMarkdown>{content}</ReactMarkdown>
      </article>
    </div>
  );
};

export default AboutPage;
